<template>
	<el-dialog :visible.sync="visible" width="400px" title="设置分成比" @close="reset('from')">
		<div slot="title">
			设置分成比
			<el-tooltip class="item" effect="dark" placement="top">
				<div slot="content">
					<p>系统根据所设分成比自动统计提成，提成=订单金额*服务费率*分成比，自动扣除【平台技术服务费】，</p>
					<p>{{ drName }}侧将换算成提成比【服务费率*分成比】展示，当月提成按最新分成比统计；</p>
				</div>
				<i class="iconfont icon-a-help-circle-obangzhu-xian ml-6"></i>
			</el-tooltip>
		</div>
		<div class="tips fz-14 mb-20 flex flex-align-center">
			<i class="iconfont mr-6 icon-a-warningjinggao-mian yx-color-warning"></i>
			每天仅可修改一次，修改后重新计算当月的所有订单（包括手动修改过的订单）如需修改历史订单，可到订单管理-批量修改订单
		</div>
		<el-form :model="divideForm" ref="from" :rules="divideRules" hide-required-asterisk>
			<el-form-item label-width="120px" prop="rate">
				<template v-slot:label>
					<span class="flex flex-align-center">
						<explain
							class="fz-12 yx-color-text-regular mr-4"
							:content="`设置${drName}通过达人分销获得的分成比，提成金额=订单付款金额*推广商品服务费率*达人分成比`"
						/>
						<span>达人分成比</span>
					</span>
				</template>
				<el-input v-model="divideForm['rate']" autocomplete="off" placeholder="请输入" maxlength="5" suffix-icon="suffix-icon"></el-input>
			</el-form-item>
			<el-form-item label-width="120px" prop="institutionRate">
				<template v-slot:label>
					<div class="flex flex-align-center">
						<explain
							class="fz-12 yx-color-text-regular mr-4"
							:content="`设置${drName}通过二级团长获得的分成比，提成金额=订单付款金额*（原始服务费率-二级团长服务费率-平台技术服务费率）*分成比`"
						/>
						<span>团长分成比</span>
					</div>
				</template>
				<el-input v-model="divideForm.institutionRate" autocomplete="off" placeholder="请输入" maxlength="5" suffix-icon="suffix-icon"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="footer-dialog">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="submit">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import Explain from '@/components/common/explain';
import { setRate } from '@/api/shopManage';
import { drRoleType } from '@/utils/dataMap';
export default {
	components: {
		Explain,
	},
	data() {
		return {
			divideForm: {
				rate: '',
				institutionRate: '',
			},
			divideRules: {
				rate: { required: true, message: '请输入达人分成比', trigger: 'blur' },
				institutionRate: { required: true, message: '请输入团长分成比', trigger: 'blur' },
			},
			visible: false,
			userId: '',
		};
	},
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		show(userId, partnerRate = '', institutionRate = '') {
			this.userId = userId;
			this.divideForm.rate = partnerRate;
			this.divideForm.institutionRate = institutionRate;
			this.visible = true;
		},
		submit() {
			const { userId } = this;
			this.$refs.from.validate(async valid => {
				if (valid) {
					const { code } = await setRate({
						userId,
						...this.divideForm,
					});
					if (code === 0) {
						this.visible = false;
						this.$message.success('设置完成，当月提成将按最新分成比统计');
						this.$emit('refresh');
					}
				}
			});
		},
		reset(from) {
			this.divideForm = {
				rate: '',
				institutionRate: '',
			};
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .suffix-icon::after {
	content: '%';
	width: 33px;
	background-color: #f7f8fa;
	border-bottom-right-radius: 2px;
	border-top-right-radius: 2px;
}
/deep/ .el-input__suffix {
	height: 92%;
	right: 1px;
	top: -1px;
}
.tips {
	padding: 10px 12px;
	background: #fef3e7;
	border: 1px solid #fba543;
	border-radius: 2px;
}
</style>
